import axiosClient from "./axios-client";

export const uploadJobFile = async (jobId, file) => {
    const formData = new FormData();

    formData.append("job_id", jobId);
    formData.append("file", file);

    const response = await axiosClient.post(
        "/files/upload",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};


export const downloadFile = (fileId, format) =>
    axiosClient.get(`/files/${fileId}/export`, {
        params: { format },
        responseType: "blob",
    });